module.exports = __webpack_public_path__ + "img/logo.b41c6090.svg";